import axios from "axios";
const CONTROLLER_PATH = "CustomerImportJob";
class CustomerImportJobService {
    //CREATE
    create(formData) {
        //formData.append('_method', 'PUT');
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    reset(formData) {
        //formData.append('_method', 'PUT');
        return axios
            .post(CONTROLLER_PATH + "/reset", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    //READ
    get(id, urlParameters, requestId) {
        return axios
            .get(CONTROLLER_PATH + (id ? "/" + id : ""), {
                params: urlParameters,
                requestId: requestId,
            })
            .then((response) => ({
                data: response.data,
                requestId: response.config.requestId,
            }));
    }
}

export default new CustomerImportJobService();
